export default {
    homeTitle1: "信用评分",
    homeContent1: "通过科学严谨的分析方法，综合考察影响个人及家庭的内在和外在的主客观环境，对其履行各种经济承诺的能力进行全面的评估和判断，并以信用分数形式表述。",

    homeTitle2: "数据服务",
    homeContent2: "在银行、电商、电信、餐饮等消费行为数据基础上，利用大数据挖掘和深度学习先进信息驱动技术，进行数据深层次开发并衍生新产品，为客户提供具体的解决方案和产品。",

    // homeTitle3: "智能风控",
    // homeContent3: "在大数据和人工智能的支撑下，构建智能反欺诈、贷前审核、贷中和贷后持续监控系统，为金融、非金融机构提供多元、立体化的全生命周期金融风控服务。",

    // homeTitle4_1: "智能导流",
    // homeContent4_1: "致力于聚合互联网、电信运营商、电商等渠道优质流量，为银行、保险、基金、证券等金融机构提供优质的智能数据资产，打造了精准链接亿万消费者金融需求智能科技云平台，为数以千计的金融机构提供高品质的导流服务。",

    // homeTitle4: "核心优势",
    // homeContent4Title:
    // "Seeder秉承科技赋能金融、数据助力普惠的美好愿景，致力于提升金融行业的技术能力。通过自主研制开发、独立知识产权的技术、工具、模型、平台，为金融合作伙伴提供多种赋能产品和解决方案。",
    // homeContentTitleSon1: "技术领先",
    // homeContentTitleSon2: "服务稳定",
    // homeContentTitleSon3: "聚焦金融",
    // homeContentTitleSon1Desc:
    // "基于业内最新的人工智能高精度算法，将其工程化并应用于金融领域。如误识率在百万分之一，人脸识别的准确率超过99%。",
    // homeContentTitleSon2Desc:
    // "提供企业级稳定、精确的大流量服务，拥有毫秒级延迟响应能力、弹性灵活高并发承载，可靠性保障高达99.99%。",
    // homeContentTitleSon3Desc:
    // "依托集团多年在东南亚金融业务，积累了众多合作伙伴和大量的业务数据，熟知各国的金融政策，能准确、高效服务于不同国家金融机构。"
};

